// extracted by mini-css-extract-plugin
export default {"accountant":"AccountantProfile_accountant__V8PIZ"};